<template>
    <div id="statistics">
        <v-overlay absolute="" opacity="0.2" :value="loader">
            <v-progress-circular :color="appColor" indeterminate size="32"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar.status" top :color="snackbar.color" :timeout="snackbar.timeout">
            <v-icon class="mr-1">{{ snackbar.icon }}</v-icon> {{ snackbar.message }}
        </v-snackbar>
        <statistics-toolbar></statistics-toolbar>
        <v-container fluid>
            <v-row>
                <v-col col="12">
                    <statistics-settings :residenceTerms="residenceTerms" :yearItems="yearItems"
                        @generateStatistics="generateStatistics">
                    </statistics-settings>
                </v-col>
                <v-col cols="12">
                    <statistics-data :data="data"></statistics-data>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import StatisticsData from '../../components/Admin/Statistics/Data';
import StatisticsSettings from '../../components/Admin/Statistics/Settings';
import StatisticsToolbar from '../../components/Admin/Statistics/Toolbar';

export default {
    name: 'statistics',
    components: {
        StatisticsData,
        StatisticsSettings,
        StatisticsToolbar
    },
    data() {
        return {
            data: {
                ageRange: {
                    data: []
                },
                buildingPreferencesFemale: {
                    data: []
                },
                buildingPreferencesMale: {
                    data: []
                },
                buildingPreferencesOther: {
                    data: []
                },
                city: {
                    data: []
                },
                country: {
                    data: []
                },
                gender: {
                    data: []
                },
                international: {
                    data: []
                },
                lifestyle: {
                    data: []
                },
                mealPlan: {
                    data: []
                },
                paymentMethod: {
                    data: []
                },
                yearOfStudy: {
                    data: []
                },
            },
            loader: true,
            residenceTerms: [],
            snackbar: {
                color: 'success',
                icon: '',
                message: '',
                status: false,
                timeout: 5000
            },
            yearItems: []
        }
    },
    methods: {
        generateStatistics(databaseType, value) {
            const that = this;
            const formData = new FormData();
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?executeStats`;

            // Parse array into string
            if (databaseType == "legacy") {
                formData.append('data', JSON.stringify({
                    databaseType: "legacy",
                    year: value.toString()
                }));
            } else {
                formData.append('data', JSON.stringify({
                    databaseType: "modern",
                    residenceTerm: value
                }));
            }

            formData.append('mode', 'executeStats');

            // GET request
            fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (json.result.match(/OK/i)) {
                        that.data.ageRange = json.data.ageRange && json.data.ageRange.data ? json.data.ageRange : that.data.ageRange;
                        that.data.buildingPreferencesFemale = json.data.buildingPreferencesFemale && json.data.buildingPreferencesFemale.data ? json.data.buildingPreferencesFemale : that.data.buildingPreferencesFemale;
                        that.data.buildingPreferencesMale = json.data.buildingPreferencesMale && json.data.buildingPreferencesMale.data ? json.data.buildingPreferencesMale : that.data.buildingPreferencesMale;
                        that.data.buildingPreferencesOther = json.data.buildingPreferencesOther && json.data.buildingPreferencesOther.data ? json.data.buildingPreferencesOther : that.data.buildingPreferencesOther;
                        that.data.city = json.data.city && json.data.city.data ? json.data.city : that.data.city;
                        that.data.country = json.data.country && json.data.country.data ? json.data.country : that.data.country;
                        that.data.gender = json.data.gender && json.data.gender.data ? json.data.gender : that.data.gender;
                        that.data.international = json.data.international && json.data.international.data ? json.data.international : that.data.international;
                        that.data.lifestyle = json.data.lifestyle && json.data.lifestyle.data ? json.data.lifestyle : that.data.lifestyle;
                        that.data.mealPlan = json.data.mealPlan && json.data.mealPlan.data ? json.data.mealPlan : that.data.mealPlan;
                        that.data.paymentMethod = json.data.paymentMethod && json.data.paymentMethod.data ? json.data.paymentMethod : that.data.paymentMethod;
                        that.data.yearOfStudy = json.data.yearOfStudy && json.data.yearOfStudy.data ? json.data.yearOfStudy : that.data.yearOfStudy;
                        that.setNotification('#1dc9b7', 'mdi-check', `Statistics data has been successfully generated.`, true);
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to view this resource. Please refresh your application.`, true);
                    } else if (!json.result.match(/OK/i)) {
                        that.setNotification('#ffb822', 'mdi-alert-circle', `Statistics data could not be retrieved. Please contact your system administrator.`, true);
                    }

                    that.setLoader(false);
                })
                .catch(function () {
                    that.setLoader(false);
                })
        },
        getStatisticsData() {
            const that = this;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getStatsConfig`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (json.result.match(/OK/i)) {
                        that.yearItems = json.data.legacy || [];
                        that.residenceTerms = json.data.modern || [];
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to view this resource. Please refresh your application.`, true);
                    } else if (!json.result.match(/OK/i)) {
                        that.setNotification('#ffb822', 'mdi-alert-circle', `Reports data could not be retrieved. Please contact your system administrator.`, true);
                    }

                    that.setLoader(false);
                })
                .catch(function () {
                    that.setLoader(false);
                })
        },
        setLoader(bool) {
            this.loader = bool;
        },
        setNotification(color, icon, message, status) {
            // Reset snackbar
            this.snackbar.status = false;

            // Set snackbar fields
            this.snackbar.color = color;
            this.snackbar.icon = icon;
            this.snackbar.message = message;
            this.snackbar.status = status;
        }
    },
    computed: {
        appColor() {
            return '#191b2a';
        }
    },
    created() {
        this.getStatisticsData();
    }
}
</script>